import { defu } from 'defu'

// Always add 'min' and 'navigation' categories
const paymentMethodsDataCategories = new Map([
  ['PagePaymentMethods', ['payment-methods', 'payment-methods-labels', 'filter-labels', 'payment-methods-collections']],
  ['PagePaymentMethodsDetail', ['payment-methods-labels', 'payment-methods-collections']],
  ['PagePaymentMethodsGuides', ['payment-methods-labels', 'payment-methods-collections']],
  ['PagePaymentMethodsGuidesRegion', ['payment-methods-labels', 'payment-methods-collections']],
  ['PagePaymentMethodsGuidesRegionCountry', ['payment-methods-labels', 'payment-methods-collections']],
  ['PagePricing', ['payment-methods-labels', 'payment-methods-collections']]
])

const paymentMethodsApiEndpoints = new Map([
  ['payment-methods', '/api/v3/payment-methods_data/payment-methods'],
  ['payment-methods-labels', '/api/v3/payment-methods_data/payment-methods-labels'],
  ['payment-methods-collections', '/api/v3/payment-methods_data/payment-methods-collections'],
  ['payment-methods-country-labels', '/api/v3/payment-methods_data/payment-methods-country-labels']
])

export const usePaymentMethodsGlobalData = () => {
  const { labels, globalContentData, localeGlobalContentData, setGlobalContentData, generateDataPromisesForContentType } = useGlobalData()

  async function fetchGlobalDataForContentType (contentType, locale) {
    const promises = generateDataPromisesForContentType(contentType, paymentMethodsDataCategories, paymentMethodsApiEndpoints, locale)
    const response = await Promise.all(promises)

    let data = {}
    response.forEach((r: any) => {
      data = defu(r, data)
    })

    setGlobalContentData(data)
  }

  return {
    labels,
    globalContentData,
    localeGlobalContentData,
    fetchGlobalDataForContentType
  }
}
